/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Exercise_Included_ToastInputs */

const en_us2_exercise_included_toast = /** @type {(inputs: Exercise_Included_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} can be suggested again`)
};

const pt_br2_exercise_included_toast = /** @type {(inputs: Exercise_Included_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} pode voltar a ser sugerido`)
};

const es_419_exercise_included_toast = /** @type {(inputs: Exercise_Included_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} puede volver a sugerirse`)
};

const pt_pt2_exercise_included_toast = /** @type {(inputs: Exercise_Included_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} pode voltar a ser sugerido`)
};

const fr_fr2_exercise_included_toast = /** @type {(inputs: Exercise_Included_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} peut de nouveau être suggéré`)
};

const de_de2_exercise_included_toast = /** @type {(inputs: Exercise_Included_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} kann wieder vorgeschlagen werden`)
};

const it_it2_exercise_included_toast = /** @type {(inputs: Exercise_Included_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} potrà essere suggerito di nuovo`)
};

/**
* | output |
* | --- |
* | "{name} can be suggested again" |
*
* @param {Exercise_Included_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_included_toast = /** @type {((inputs: Exercise_Included_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Included_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_included_toast(inputs)
	if (locale === "es-419") return es_419_exercise_included_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_included_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_included_toast(inputs)
	if (locale === "de-DE") return de_de2_exercise_included_toast(inputs)
	if (locale === "it-IT") return it_it2_exercise_included_toast(inputs)
	return en_us2_exercise_included_toast(inputs)
});
export { exercise_included_toast as "exercise.included_toast" }